import {Injectable} from '@angular/core';
import {Message} from './message';

type MessageTimers = {
  ttlCountdownTimer: any;
  removeTimer: any;
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: Message[] = [];
  private timers: Map<Message, MessageTimers> = new Map<Message, MessageTimers>();

  addSuccess(text: string) {
    const message: Message = {message: text, type: 'success', ttl: 5, noTtl: false};
    this.messages.push(message);
    this.createMessageTimers(5000, message);
  }

  addDanger(text: string) {
    const message: Message = {message: text, type: 'danger', ttl: 60, noTtl: false};
    this.messages.push(message);
    this.createMessageTimers(60000, message);
  }

  addInfo(text: string) {
    const message: Message = {message: text, type: 'info', ttl: 10, noTtl: false};
    this.messages.push(message);
    this.createMessageTimers(10000, message);
 }

  addWarning(text: string) {
    const message: Message = {message: text, type: 'warning', ttl: 30, noTtl: false};
    this.messages.push(message);
    this.createMessageTimers(30000, message);
  }

  private createMessageTimers(removeTimeoutMs: number, message: Message) {
    const timers: MessageTimers = {
      removeTimer: this.createRemoveTimeout(removeTimeoutMs, message),
      ttlCountdownTimer: this.createMessageTtlTimer(message),
    };
    this.timers.set(message, timers);
  }

  private createMessageTtlTimer(message: Message) {
    return setTimeout(() => {
      if (message.noTtl) {
        return;
      }
      message.ttl = message.ttl - 1;
      if (message.ttl > 0) {
        // timer reference must be updated as well
        const timers = this.timers.get(message);
        timers.ttlCountdownTimer = this.createMessageTtlTimer(message);
      }
    }, 1000);
  }

  private createRemoveTimeout(milliseconds: number, message: Message) {
    return setTimeout(() => {
      if (message.noTtl) {
        return;
      }
      this.removeMessage(message);
    }, milliseconds);
  }

  removeMessage(message: Message, ): void {
    const index = this.messages.indexOf(message);
    if (index > -1) {
      const timer = this.timers.get(message);
      // make sure ttl is not being updated after message is already removed
      clearTimeout(timer.removeTimer);
      clearTimeout(timer.ttlCountdownTimer);
      this.timers.delete(message);
      this.messages.splice(index, 1);
    }
  }

  clear() {
    this.messages = [];
  }
}
